export default [
  {
    path: "/unit",
    name: "Unit",
    // component: () => import("@/page/test.vue"),
    component: () => import("@/page/unit/Unit.vue"),
  },
];
